export const REMAN_VIEW_ITEM_LIST = {
  item_list_id: 'PCC PDP - Upsell Marketing Associations',
  item_list_name: 'PCC PDP - Upsell Marketing Associations'
};

export const REMAN_SELECT_ITEM = {
  item_list_id: 'PCC PDP - Upsell Marketing Associations',
  item_list_name: 'PCC PDP - Upsell Marketing Associations'
};

export const REMAN_ADD_TO_CART = {
  item_list_id: 'PCC PDP - Upsell Marketing Associations',
  item_list_name: 'PCC PDP - Upsell Marketing Associations'
};
